import type { SalesIntelligenceThunkDeps } from "app/pages/sales-intelligence/types/state/effects";
import { allTrackers } from "app/services/track/track";
import queryClient from "single-spa/react-app/query-client";

import salesApiService from "../services/salesApiService";
import salesSettingsHelper from "../services/salesSettingsHelper";

const siThunkDependencies: SalesIntelligenceThunkDeps = {
    api: salesApiService,
    settingsHelper: salesSettingsHelper,
    trackEvent: allTrackers.dispatchTrackEvent.bind(allTrackers),
    queryClient: queryClient,
};

export default siThunkDependencies;
